import { freddyTheme } from '@coolblue-development/freddy';
export default function getAnchorBarItemLinkStyles({ isActive, }) {
    const { color } = freddyTheme;
    const { background: backgroundColor, font: fontColor, border: borderColor } = color;
    return {
        textDecoration: 'none',
        position: 'relative',
        '&:after': {
            position: 'absolute',
            content: '""',
            left: 0,
            right: 0,
            bottom: `-0.1rem`,
            height: isActive ? '0.2rem' : '0.1rem',
            background: isActive
                ? backgroundColor.interactiveControlSelectedBase
                : backgroundColor.interactiveInverseDisabled,
        },
        '&:hover': {
            color: fontColor.interactiveBase,
            backgroundColor: backgroundColor.interactiveHovered,
            textDecoration: 'none !important',
            '&:after': {
                background: isActive
                    ? backgroundColor.interactiveControlSelectedBase
                    : backgroundColor.interactiveControlContrastHovered,
            },
        },
        '&:focus-visible': {
            outline: 0,
            span: {
                outlineWidth: freddyTheme.spacing[50],
                outlineStyle: 'solid',
                outlineOffset: freddyTheme.spacing[100],
                outlineColor: borderColor.interactiveMainHovered,
                borderRadius: freddyTheme.spacing[100],
            },
            backgroundColor: backgroundColor.interactiveInverseDisabled,
        },
    };
}
//# sourceMappingURL=AnchorBarItem.styles.js.map